import apiClient from "../apiClient";
import { BLOG_ENDPOINTS } from "../endpoints/blog";

export const fetchBlogsList = async ({
  searchText = "",
  pageSize = 12,
  pageIndex = 1,
  regionTagSlug = [],
} = {}) => {
  try {
    const payload = {
      searchText,
      pageSize,
      pageIndex,
    };

    if (Array.isArray(regionTagSlug) && regionTagSlug.length) {
      payload.regionTagSlug = regionTagSlug;
    }

    const response = await apiClient.post(BLOG_ENDPOINTS.getBlogsList, payload);
    return response.data;
  } catch (error) {
    console.error("Error fetching blogs list:", error);
    throw error;
  }
};

export const fetchThingsToDoByMonthList = async () => {
  try {
    const response = await apiClient.get(BLOG_ENDPOINTS.getThingsToDoByMonthList);
    return response.data;
  } catch (error) {
    console.error("Error fetching things to do by month list:", error);
    throw error;
  }
};

export const fetchBlogDetailBySlug = async (slug = "") => {
  try {
    const response = await apiClient.get(BLOG_ENDPOINTS.getBlogDetailUsingSlug, {
      params: { Slug: slug },
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching blog detail:", error);
    throw error;
  }
};

export const fetchRecentBlogs = async (numberOfBlog = 5) => {
  try {
    const response = await apiClient.get(BLOG_ENDPOINTS.getRecentBlogs, {
      params: { numberOfBlog },
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching recent blogs:", error);
    throw error;
  }
};

export const submitBlogEnquiry = async (payload) => {
  try {
    const response = await apiClient.post(
      BLOG_ENDPOINTS.submitBlogEnquiry,
      payload
    );
    return response.data;
  } catch (error) {
    console.error("Error submitting blog enquiry:", error);
    throw error;
  }
};

export const saveBlogSubscriber = async (payload) => {
  try {
    const response = await apiClient.post(BLOG_ENDPOINTS.saveSubscriber, payload);
    return response.data;
  } catch (error) {
    console.error("Error saving blog subscriber:", error);
    throw error;
  }
};

export const saveBlogComment = async (payload) => {
  try {
    const response = await apiClient.post(BLOG_ENDPOINTS.saveBlogComment, payload);
    return response.data;
  } catch (error) {
    console.error("Error saving blog comment:", error);
    throw error;
  }
};

export const fetchBlogsByAuthor = async ({
  authorSlug = "",
  pageSize = 12,
  pageIndex = 1,
} = {}) => {
  try {
    const response = await apiClient.post(BLOG_ENDPOINTS.getBlogsByAuthor, {
      authorSlug,
      pageSize,
      pageIndex,
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching blogs by author:", error);
    throw error;
  }
};

export const fetchBlogCategories = async () => {
  try {
    const response = await apiClient.get(BLOG_ENDPOINTS.getBlogCategories);
    return response.data;
  } catch (error) {
    console.error("Error fetching blog categories:", error);
    throw error;
  }
};

export const fetchBlogsByCategorySlug = async (categorySlug = "") => {
  try {
    const response = await apiClient.get(BLOG_ENDPOINTS.getBlogsByCategorySlug, {
      params: { categorySlug },
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching blogs by category slug:", error);
    throw error;
  }
};
